import React from 'react';

import { EpdVersionHistoryData } from '../version-history/utils/EpdVersionHistoryDataContext';

const EpdComparedVersionHistoryDataContext = React.createContext<EpdVersionHistoryData | null>(null);
export default EpdComparedVersionHistoryDataContext;

export function useEpdComparedVersionHistoryData(): EpdVersionHistoryData {
  const data = React.useContext(EpdComparedVersionHistoryDataContext);
  if (!data) {
    throw new Error('This hook must be used when all data is loaded.');
  }
  return data;
}

export function useEpdComparedVersionHistoryDataOrWhileLoadingThenNull(): EpdVersionHistoryData | null {
  return React.useContext(EpdComparedVersionHistoryDataContext);
}
